import React, { useEffect, useState } from "react";

export default function Section1() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 425);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 425);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="Section1 w-full relative pt-0 sm:pt-[100px]">
      {isDesktop ? (
        <img
          src="../../../../assets/bg-influencer-registration.jpg"
          alt=""
          className="object-fill w-full h-full"
        />
      ) : (
        <img
          src="../../../assets/mob-banner-influencer-1.jpg"
          alt=""
          className="h-auto w-full sm:h-auto object-fit"
        />
      )}
    </div>
  );
}
